import { Controller, useFormContext } from "react-hook-form";

import { NcRadioButtonGroup, NcRadioButtonGroupProps } from "./nc-radio-button-group";

export interface NcFormRadioButtonGroupProps
  extends Omit<
    NcRadioButtonGroupProps,
    "name" | "validate" | "onBlur" | "value" | "validationBehavior"
  > {
  name: string; // Was optional in NcRadioButtonGroupProps and is now required
}

const FormRadioButtonGroup = ({ name, onChange, ...props }: NcFormRadioButtonGroupProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcRadioButtonGroup
          name={name}
          value={value}
          onChange={value => {
            formOnChange(value);
            onChange?.(value);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};

export const NcFormRadioButtonGroup = Object.assign(FormRadioButtonGroup, {
  Radio: NcRadioButtonGroup.Radio,
  Indicator: NcRadioButtonGroup.Indicator,
});
